import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import PublicForm from "@/pages/PublicForm";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import OrgEditor from "@/pages/OrgEditor";
import DevSaasLog from "@/pages/DevSaasLog";
import { EmbedStatus } from "@/components/EmbedStatus";
import { isEmbedded } from "@/lib/integration";
import { getDict } from "@/i18n";

function SkipLink() {
  return (
    <a href="#main-content" className="skip-link">
      {getDict("fr").skipToContent}
    </a>
  );
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (isEmbedded && !user) return <EmbedStatus />;
  if (!ready) return <div className="flex min-h-screen items-center justify-center bg-slate-100" />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <SkipLink />
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={isEmbedded ? <Navigate to="/admin" replace /> : <Home />} />
            <Route path="/form/:token" element={<PublicForm />} />
            <Route path="/embed/:token" element={<PublicForm embed />} />
            <Route
              path="/admin/login"
              element={isEmbedded ? <Navigate to="/admin" replace /> : <AdminLogin />}
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/org/:id"
              element={
                <ProtectedRoute>
                  <OrgEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dev/saas-log"
              element={
                <ProtectedRoute>
                  <DevSaasLog />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
